// A CALENDAR DAY on the wire — `YYYY-MM-DD`, a real day of the Gregorian
// calendar (the SCHEMA `_on` rule: a plain string end to end, never a zoned
// instant). The shape regex alone lets `2024-02-31` through to Postgres as a
// 500; the round-trip through Date.UTC catches every impossible day at the
// wire (a 400 / a row error), where it belongs.
import { z } from 'zod';
export const CALENDAR_DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
/** true iff `v` is a real calendar day written `YYYY-MM-DD`. */
export function isCalendarDay(v) {
    const m = CALENDAR_DAY_RE.exec(v);
    if (!m)
        return false;
    const y = Number(m[1]);
    const mo = Number(m[2]);
    const d = Number(m[3]);
    const t = new Date(Date.UTC(y, mo - 1, d));
    return t.getUTCFullYear() === y && t.getUTCMonth() === mo - 1 && t.getUTCDate() === d;
}
export const CalendarDaySchema = z
    .string()
    .regex(CALENDAR_DAY_RE, 'expected YYYY-MM-DD')
    .refine(isCalendarDay, { message: 'not a real calendar day' });
